const BUYER_SCHEDULE_DEMO_URL = `https://meetings.hubspot.com/luke-powers/website-demo-scheduler?subject=${encodeURIComponent(
  'Parts Hub Pro'
)}`
const DEALER_SCHEDULE_DEMO_URL = `https://meetings.hubspot.com/luke-powers/website-demo-scheduler?subject=${encodeURIComponent(
  'Sales Hub Pro'
)}`

export default { BUYER_SCHEDULE_DEMO_URL, DEALER_SCHEDULE_DEMO_URL }
